import React, { Component } from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";

import Login from "./pages/Login";
import RestaurantsList from "./pages/RestaurantsList";
import NotFound from "./pages/NotFound";
import Admin from "./pages/Admin";
import UserLogin from "./pages/UserLogin";
// import Test from "./pages/test";
import history from "./history";
import { isUser, Authorization } from "./static.js";

export default class Routes extends Component {
  render() {
    const username = Authorization().userName;
    return (
      <Router history={history}>
        <Switch>
          {!isUser && (
            <Route path="/Login" render={(props) => <Login {...props} />} />
          )}

          {isUser && (
            <Route
              path="/Login/:id"
              render={(props) => <UserLogin {...props} />}
            />
          )}
          <Route
            path="/Restaurants"
            render={(props) => <RestaurantsList {...props} />}
          />
          {/* <Route path="/Test" render={(props) => <Test {...props} />} /> */}
          <Route path="/Admin" component={Admin} />
          <Route
            exact
            path="/"
            render={(props) => (
              <Redirect
                to={
                  !isUser
                    ? "/Restaurants"
                    : localStorage.getItem("code")
                    ? "/Login/" + localStorage.getItem("code")
                    : "NotFound"
                }
              />
            )}
          />
          <Route component={NotFound} />
        </Switch>
      </Router>
    );
  }
}
